<script setup lang="ts"></script>

<template>
  <article
    class="white relative flex flex-col gap-4 overflow-hidden rounded-lg border border-gray-100 bg-white p-6"
  >
    <div class="absolute right-0 top-0 h-6 w-14 animate-pulse rounded-bl-2xl bg-gray-200" />

    <header>
      <div class="flex items-center gap-2 rounded-lg">
        <figure class="flex-shrink-0 rounded-lg">
          <div class="h-5 w-5 animate-pulse rounded bg-gray-200" />
        </figure>
        <div class="flex w-full flex-col gap-0.5">
          <div class="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
        </div>
      </div>

      <div class="mt-1 h-4 w-1/2 animate-pulse rounded bg-gray-200" />

      <div class="mt-3 h-6 w-3/4 animate-pulse rounded bg-gray-200" />

      <div class="mt-2 h-4 w-1/4 animate-pulse rounded bg-gray-200" />
    </header>
  </article>
</template>
